/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Button, Link, Text, useMultiStyleConfig} from '@chakra-ui/react'
import usePromoCodeFields from '@salesforce/retail-react-app/app/components/forms/usePromoCodeFields'
import Field from '../../components/field/index'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PromoCodeFields = ({form, prefix = '', ...props}) => {
    const fields = usePromoCodeFields({form, prefix})
    const style = useMultiStyleConfig('OrderSummary', {})
    const {locale} = useMultiSite()
    const {promoCode} = style
    const code = form.watch('code')

    return (
        <Box {...promoCode?.inputContainer} aria-labelledby="code-feedback" {...props}>
            <Text {...promoCode?.inputContainerHeader}>
                <FormattedMessage
                    id="use_promo_code_fields.label.promo_code"
                    defaultMessage="Promo Code"
                />
            </Text>

            <Field inputProps={promoCode?.inputProps} {...fields.code} shouldDisplaySuccess={false}>
                <Button
                    type="submit"
                    {...promoCode?.applyButton}
                    isLoading={form.formState.isSubmitting}
                    disabled={code?.length < 3}
                >
                    <FormattedMessage defaultMessage="Apply" id="promo_code_fields.button.apply" />
                </Button>
            </Field>

            {/* Remove logic on Release 2  */}
            {locale?.alias === 'en-gb' && (
                <Link
                    {...promoCode?.referralLink}
                    href="https://mention-me.com/me/referee/referee_search_integration/mm0dcc4f72/9ea2fa82715022d3a1a5ec2243323ec7f5d4e5d0/p/checkout?implementation=link&locale=en_GB"
                    isExternal
                >
                    <Text>
                        <FormattedMessage
                            defaultMessage="Been referred by a friend?"
                            id="promo_code_fields.referral_link"
                        />
                    </Text>
                </Link>
            )}
        </Box>
    )
}

PromoCodeFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string,
}

export default PromoCodeFields
